<template>
    <div>
        <app-card
            headerIcon="inventory_2"
            :heading="$t('lang.WorkOrders')"
            colClasses=""
            customClasses="mb-0"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :footer="true"
            :fullBlock="true"
            refreshMethod="refreshWorkOrders"
            :reload="reload"
        >
            <work-orders></work-orders>
            <v-spacer slot="footer"></v-spacer>
            <v-btn slot="footer" class="mr-2" color="primary" @click="$router.push({ name: 'work_orders' })" small>{{ $t("lang.view_all") }}</v-btn>
            <v-btn slot="header" icon small @click="refreshWorkOrders"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import WorkOrders from "App_components/Widgets/WorkOrders.vue";
import { mapActions } from "vuex";
export default {
    components: {
        WorkOrders,
    },
    props: {
        refreshMethod: {
            type: Function,
        },
    },
    data() {
        return {
            name: "work_orders",
            reload: false,
        };
    },
    methods: {
        ...mapActions(["fetchWorkOrders"]),
        async refreshWorkOrders() {
            this.reload = true;
            this.$store.commit("mutate", {
                property: "dashboard_work_orders",
                with: [],
            });
            this.fetchWorkOrders({
                body: {
                    status: "new_request",
                    dashboard: true,
                    options: 1,
                },
            }).then((data) => {
                this.$store.commit("mutate", {
                    property: "dashboard_work_orders",
                    with: data.work_orders,
                });
                this.reload = false;
            });
        },
    },
};
</script>
